/**
 * Dish image utility — returns a usable image URL for a menu item, falling
 * back to a branded "No photo yet" placeholder when the owner hasn't
 * uploaded one.
 */
export const DISH_PLACEHOLDER = "/dish-placeholder.svg";

/**
 * Pick the best image for a menu item, preferring the primary `image_url`
 * then the first entry in `images[]`, else the placeholder.
 */
export function dishImg(item) {
  if (!item) return DISH_PLACEHOLDER;
  const primary = (item.image_url || "").trim();
  if (primary) return primary;
  const first = (item.images || []).find((u) => typeof u === "string" && u.trim().length > 0);
  return first || DISH_PLACEHOLDER;
}

/**
 * onError handler — swap broken images with the placeholder. Use as:
 *   <img src={dishImg(item)} onError={onDishImgError} />
 */
export function onDishImgError(e) {
  if (e?.currentTarget && e.currentTarget.src && !e.currentTarget.src.endsWith(DISH_PLACEHOLDER)) {
    e.currentTarget.src = DISH_PLACEHOLDER;
  }
}
